export default __webpack_public_path__ + "static/media/building_blue.9d8623e0.svg";